export default __webpack_public_path__ + "static/media/gallery_00.a2762a9b.jpg";